import { SetLeftCenterIcon } from './SetLeftCenterIcon';

/**
 * author: Simran
 * id 9C04991C-6A68-4634-885F-A4D6E2816AFF
 * name set-left-center
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-left-center.svg
 * tags
 * - Database 
 */
export const SetLeftCentreIcon = SetLeftCenterIcon;
export default SetLeftCentreIcon